import type * as React from 'react';
import { post } from '@Domain/Api';
import secondFactorVerified, {
	type SecondFactorVerifiedAction,
	type SecondFactorVerifiedPayload,
} from '@Application/Security/Authentications/Actions/secondFactorVerified';
import secondFactorVerificationFailed, {
	type SecondFactorVerificationFailedAction,
} from '@Application/Security/Authentications/Actions/secondFactorVerificationFailed';
import type VerifySecondFactor from '@Application/Security/Authentications/Commands/VerifySecondFactor';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = SecondFactorVerifiedAction | SecondFactorVerificationFailedAction;

export default (command: VerifySecondFactor) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await post<SecondFactorVerifiedPayload>(
				`${parameters.api.host}/api/mfa/verification`,
				command.toJSON(),
				{ retryOnUnauthorized: false },
			);

			const action = secondFactorVerified(payload);
			dispatch(action);
			return action;
		} catch (error) {
			const action = secondFactorVerificationFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
